/* tslint:disable */
import {
  Game,
  PlayerPrize
} from '../index';

declare var Object: any;
export interface PrizeInterface {
  "title"?: string;
  "description"?: string;
  "buyNowUrl"?: string;
  "image1"?: any;
  "image2"?: any;
  "image3"?: any;
  "image4"?: any;
  "image5"?: any;
  "image6"?: any;
  "type"?: string;
  "cashPrizeValue"?: string;
  "winPattern"?: Array<any>;
  "exactMatchImage"?: any;
  "position"?: number;
  "gameId"?: any;
  "isTied"?: boolean;
  "tiedPlayers"?: Array<any>;
  "winnerId"?: string;
  "prizeConfetti"?: any;
  "id"?: any;
  game?: Game;
  playerPrize?: PlayerPrize[];
}

export class Prize implements PrizeInterface {
  "title": string;
  "description": string;
  "buyNowUrl": string;
  "image1": any;
  "image2": any;
  "image3": any;
  "image4": any;
  "image5": any;
  "image6": any;
  "type": string;
  "cashPrizeValue": string;
  "winPattern": Array<any>;
  "exactMatchImage": any;
  "position": number;
  "gameId": any;
  "isTied": boolean;
  "tiedPlayers": Array<any>;
  "winnerId": string;
  "prizeConfetti": any;
  "id": any;
  game: Game;
  playerPrize: PlayerPrize[];
  constructor(data?: PrizeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Prize`.
   */
  public static getModelName() {
    return "Prize";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Prize for dynamic purposes.
  **/
  public static factory(data: PrizeInterface): Prize{
    return new Prize(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Prize',
      plural: 'prizes',
      path: 'prizes',
      idName: 'id',
      properties: {
        "title": {
          name: 'title',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "buyNowUrl": {
          name: 'buyNowUrl',
          type: 'string'
        },
        "image1": {
          name: 'image1',
          type: 'any'
        },
        "image2": {
          name: 'image2',
          type: 'any'
        },
        "image3": {
          name: 'image3',
          type: 'any'
        },
        "image4": {
          name: 'image4',
          type: 'any'
        },
        "image5": {
          name: 'image5',
          type: 'any'
        },
        "image6": {
          name: 'image6',
          type: 'any'
        },
        "type": {
          name: 'type',
          type: 'string'
        },
        "cashPrizeValue": {
          name: 'cashPrizeValue',
          type: 'string'
        },
        "winPattern": {
          name: 'winPattern',
          type: 'Array&lt;any&gt;'
        },
        "exactMatchImage": {
          name: 'exactMatchImage',
          type: 'any'
        },
        "position": {
          name: 'position',
          type: 'number',
          default: 1
        },
        "gameId": {
          name: 'gameId',
          type: 'any'
        },
        "isTied": {
          name: 'isTied',
          type: 'boolean',
          default: false
        },
        "tiedPlayers": {
          name: 'tiedPlayers',
          type: 'Array&lt;any&gt;'
        },
        "winnerId": {
          name: 'winnerId',
          type: 'string'
        },
        "prizeConfetti": {
          name: 'prizeConfetti',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
        game: {
          name: 'game',
          type: 'Game',
          model: 'Game',
          relationType: 'belongsTo',
                  keyFrom: 'gameId',
          keyTo: 'id'
        },
        playerPrize: {
          name: 'playerPrize',
          type: 'PlayerPrize[]',
          model: 'PlayerPrize',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'prizeId'
        },
      }
    }
  }
}
